import { Fragment } from 'react'

import { Heading } from '@ui/typography/Heading'

import { Wrapper, Subtitle, Text } from './styles'
import { ProcessProps } from './types'

export function Process({ title, processSteps }: ProcessProps) {
  return (
    <Wrapper>
      {title && <Heading title={title} />}
      {processSteps?.map(({ id, subtitle, text }) => (
        <Fragment key={id}>
          <Subtitle as="h3">{subtitle}</Subtitle>
          {text && <Text>{text}</Text>}
        </Fragment>
      ))}
    </Wrapper>
  )
}
